/** 
 * Checkbox 
 * 
 * @param {boolean} [white]
 * @param {boolean} [small]
 * @param {boolean} [large]
 * @param {number}  [size]
 * @param {string}  [color]
 * @param {string}  [label]
 * @param {array}   [children]
 * @param {boolean} [checked]
 * 
 */



import React from 'react';

import { Text } from '../Text';
import { Button } from '../Button';

export function Checkbox({
  white,
  small,
  large, 
  size,
  color = "#243746",
  label,
  children,
  checked,
  ...props
}) {
  
  if(white) {
    color = "#ffffff";
  }
  
  const labelProps = {small, large, size};
  
  return (
    <Button tertiary {...props} {...labelProps}>
      
      <div 
        style={{
          flex: '0 0 auto',
          width: 12,
          height: 12,
          border: `1px solid ${color}`,
          marginRight: 8,
          backgroundColor: checked ? color : "transparent",
        }}
      />
      
      {label ? (
        <Text block color={color} {...labelProps}>{label}</Text>
      ) : (
        children
      )}
      
      
    </Button>
  );
}